import React from 'react';
import styled from 'styled-components';
import {
  minBreakpointQuery,
  standardColours,
  brandColours,
  fontSize,
} from '../styles';
import { Svg } from './ui';
import liveAvailabilityIcon from '../images/live-availability-icon.svg';

const StyledLiveAvailability = styled.p`
  display: flex;
  align-items: center;
  margin: 15px 0;
  ${fontSize(11)};
  line-height: 1.1;

  ${minBreakpointQuery.small`
    ${fontSize(12)};
  `}

  ${minBreakpointQuery.large`
    ${fontSize(13)};
  `}
`;

const StyledIcon = styled(Svg)`
  margin-right: 6px;
  height: 20px;
  width: 20px;
  min-height: 20px;
  min-width: 20px;
  fill: ${({ alt }) => (alt ? standardColours.white : brandColours.primary)};
  transition: all 0.25s ease-in-out;

  ${minBreakpointQuery.small`
    margin-right: 7px;
    height: 22px;
    width: 22px;
    min-height: 22px;
    min-width: 22px;
  `}

  ${minBreakpointQuery.large`
    margin-right: 8px;
    height: 24px;
    width: 24px;
    min-height: 24px;
    min-width: 24px;
  `}

  @keyframes flashCenter {
    0%,
    to {
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
  }

  @keyframes flashInner {
    0%,
    to {
      opacity: 0;
    }
    50% {
      opacity: 0.5;
    }
  }

  @keyframes flashOuter {
    0%,
    to {
      opacity: 0;
    }
    50% {
      opacity: 0.25;
    }
  }

  path {
    &:first-child {
      opacity: 1;
      animation: flashCenter 1s ease-in-out infinite both;
      animation-delay: 0s;
    }

    &:nth-child(2) {
      opacity: 0.5;
      animation: flashInner 1s ease-in-out infinite both;
      animation-delay: 0.15s;
    }

    &:last-child {
      opacity: 0.25;
      animation: flashOuter 1s ease-in-out infinite both;
      animation-delay: 0.25s;
    }
  }
`;

const LiveAvailability = ({ text, alt, ...props }) => (
  <StyledLiveAvailability {...props}>
    <StyledIcon image={liveAvailabilityIcon} alt={alt} />
    <span
      dangerouslySetInnerHTML={{
        __html:
          text ||
          'Live availability - Book now and your reservation will be instantly guaranteed',
      }}
    />
  </StyledLiveAvailability>
);

export default LiveAvailability;
